
import Event from "./event"

const SendPhoneEnquiry = {
  track(){
    Event.track({category: "send_phone_enquiry", action: "send"})
  },
}

const SendSpaciousEnquiry = {
  track(){
    Event.track({category: "send_spacious_enquiry", action: "send"})
  },
}

export default {
  SendPhoneEnquiry,
  SendSpaciousEnquiry,
}
